import { MAX_LIMIT } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/**
 * 공개 상품 고르기 목록 — 배너 연결 상품 선택 상자처럼 검색 없이 한 번에 펼쳐 고르는 곳에서 쓴다.
 * 한 페이지 상한(MAX_LIMIT)까지 받는다.
 */
export const usePublishedProductOptionsQuery = () =>
  trpc.productManagement.products.list.useQuery({
    page: 1,
    limit: MAX_LIMIT,
    status: 'PUBLISHED',
  });
